var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation } from "react-query";
import { queryClient } from "frontend/src/domain/query-client";
import { copyPlaylist, createPlaylist, deletePlaylist, playlistsApi, updatePlaylist, } from "frontend/src/api/playlists";
import { notify } from "frontend/src/features/notifications";
import { cacheKey } from "./shared";
export var useCreatePlaylist = function () {
    var mutation = useMutation(function (payload) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // const title = payload?.title ?? "Новый плейлист";
            // if (!payload?.playlists || payload.playlists.length === 0) {
            //   return createPlaylist({
            //     type,
            //     title,
            //     tracks: [],
            //     isPublished: false,
            //     image: null,
            //     businessTypes: [],
            //   });
            // }
            //
            // const tracks = (await getManyPlaylistsDetails(payload.playlists)).flatMap(
            //   (playlist) => playlist.tracks.map((track) => track.id)
            // );
            return [2 /*return*/, createPlaylist(__assign({}, payload))];
        });
    }); }, {
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    });
    return {
        run: mutation.mutate,
        isLoading: mutation.isLoading,
        isSuccess: mutation.isSuccess,
        data: mutation.data,
    };
};
export var useCopyPlaylist = function () {
    var _a = useMutation(copyPlaylist, {
        onError: function () {
            notify({
                variant: "error",
                message: "При копировании плейлиста произошла ошибка",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Скопировано в «Мои плейлисты»" });
            return queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    return {
        do: function (id) { return mutate(id); },
        isLoading: isLoading,
    };
};
export var useDeletePlaylist = function () {
    var _a = useMutation(deletePlaylist, {
        onMutate: function (playlistId) { return __awaiter(void 0, void 0, void 0, function () {
            var cache, queries;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        cache = queryClient.getQueryCache();
                        queries = cache.findAll(cacheKey);
                        queries.forEach(function (query) {
                            return queryClient.setQueryData(query.queryKey, function (response) {
                                if (!response)
                                    return response;
                                // [{ id, ... }, ...]
                                if (Array.isArray(response)) {
                                    return response.filter(function (playlist) { return playlist.id !== playlistId; });
                                }
                                // { items: [{ id, ... }, ...], ... }
                                if (Array.isArray(response.items)) {
                                    return __assign(__assign({}, response), { items: response.items.filter(function (playlist) { return playlist.id !== playlistId; }) });
                                }
                                // одиночный PlaylistDetail
                                if (response.id === playlistId) {
                                    return undefined;
                                }
                                return response;
                            });
                        });
                        return [2 /*return*/];
                }
            });
        }); },
        onError: function () {
            notify({
                variant: "error",
                message: "При удалении плейлиста произошла ошибка",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Плейлист удален" });
            return queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading;
    return {
        do: function (id) { return mutate(id); },
        isLoading: isLoading,
    };
};
export var useUpdatePlaylist = function () {
    var _a = useMutation(updatePlaylist, {
        onMutate: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(cacheKey)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, queryClient.getQueryData(cacheKey)]; // TODO: add optimistic update
                }
            });
        }); },
        onError: function (_, __, context) {
            queryClient.setQueryData(cacheKey, context);
            notify({
                variant: "error",
                message: "При обновлении плейлиста произошла ошибка.",
            });
        },
        onSuccess: function () {
            notify({ variant: "success", message: "Плейлист обновлен." });
        },
        onSettled: function () {
            queryClient.invalidateQueries(cacheKey);
        },
    }), mutate = _a.mutate, isLoading = _a.isLoading, isSuccess = _a.isSuccess, data = _a.data;
    return {
        data: data,
        do: function (playlist) { return mutate(playlist); },
        isLoading: isLoading,
        isSuccess: isSuccess,
    };
};
export var usePublishPlaylist = function () {
    return useMutation(playlistsApi.publish, {
        onMutate: function (_a) {
            var id = _a.id, publish = _a.publish;
            return __awaiter(void 0, void 0, void 0, function () {
                var playlists;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, queryClient.cancelQueries([cacheKey])];
                        case 1:
                            _b.sent();
                            playlists = queryClient.getQueryData([cacheKey]);
                            if (playlists) {
                                queryClient.setQueryData([cacheKey], playlists.map(function (playlist) {
                                    return playlist.id === id
                                        ? __assign(__assign({}, playlist), { isPublished: publish }) : playlist;
                                }));
                            }
                            return [2 /*return*/, { playlists: playlists }];
                    }
                });
            });
        },
        onSuccess: function (_, variables) {
            var message = variables.publish
                ? "Плейлист опубликован"
                : "Плейлист снят с публикации";
            notify({ variant: "success", message: message });
        },
        onSettled: function () { return queryClient.invalidateQueries(cacheKey); },
    });
};
